module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedic"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("This book is dedicated to my husband,"), _c('br'), _vm._v("Jonathan Cohen, and to Nancy Bare and"), _c('br'), _vm._v("Lynn Cohen, two indispensable “Ys”"), _c('br'), _vm._v("in our own DIY wedding.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4293194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Dedication.vue
// module id = 69
// module chunks = 0